"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dimensions_1 = require("../_commons/dimensions");
var CoreBubbleChart_1 = require("./CoreBubbleChart");
var withChart_1 = require("../_base/withChart");
//
// Internals
//
var bubbleChartDefinition = {
    chartName: "BubbleChart",
    bucketPropsKeys: ["xAxisMeasure", "yAxisMeasure", "size", "viewBy", "filters", "sortBy"],
    bucketsFactory: function (props) {
        return [
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.MEASURES, props.xAxisMeasure),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.SECONDARY_MEASURES, props.yAxisMeasure),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.TERTIARY_MEASURES, props.size),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.VIEW, props.viewBy),
        ];
    },
    executionFactory: function (props, buckets) {
        var _a;
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        return (_a = backend
            .withTelemetry("BubbleChart", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters))
            .withSorting.apply(_a, props.sortBy).withDimensions(dimensions_1.pointyChartDimensions)
            .withExecConfig(execConfig);
    },
};
var WrappedBubbleChart = withChart_1.withChart(bubbleChartDefinition)(CoreBubbleChart_1.CoreBubbleChart);
/**
 * [BubbleChart](https://sdk.gooddata.com/gooddata-ui/docs/bubble_chart_component.html)
 *
 * Bubble chart shows data as bubbles using Cartesian coordinates. Bubble charts typically have three measures, one
 * for the X-axis, one for the Y-axis, and one that determines the size of each bubble. The data is sliced by an
 * attribute, with each bubble (an attribute item) noted with a different color.
 *
 * @public
 */
exports.BubbleChart = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.xAxisMeasure, props.yAxisMeasure, props.size, props.viewBy, props.filters, props.sortBy], props.placeholdersResolutionContext), xAxisMeasure = _a[0], yAxisMeasure = _a[1], size = _a[2], viewBy = _a[3], filters = _a[4], sortBy = _a[5];
    return (react_1.default.createElement(WrappedBubbleChart, tslib_1.__assign({}, props, {
        xAxisMeasure: xAxisMeasure,
        yAxisMeasure: yAxisMeasure,
        size: size,
        viewBy: viewBy,
        filters: filters,
        sortBy: sortBy,
    })));
};
//# sourceMappingURL=BubbleChart.js.map